  /* eslint-disable object-shorthand */
  /* eslint-disable prefer-arrow-callback */
  /* eslint-disable vars-on-top */
  /* eslint-disable strict */
  /* eslint-disable no-var */
  /* eslint-disable complexity */
  (async function (algolia) {
    'use strict';
    var instantsearch = algolia.externals.instantsearch;
    var algoliasearch = algolia.externals.algoliasearch;
    var searchBox = algolia.externals.widgets.searchBox;
    var stats = algolia.externals.widgets.stats;
    var sortBy = algolia.externals.widgets.sortBy;
    var clearRefinements = algolia.externals.widgets.clearRefinements;
    var panel = algolia.externals.widgets.panel;
    var hits = algolia.externals.widgets.infiniteHits;
    var pagination = algolia.externals.widgets.pagination;
    var configure = algolia.externals.widgets.configure;
    var index_suffix = await algolia.config.index_suffix;
    var connectCurrentRefinements =
      algolia.externals.connectors.connectCurrentRefinements;

    var collectionPageEnabled =
      algolia.is_collection_results_page &&
      algolia.config.instant_search_enabled_on_collection;

    // Check if header InstantSearch container exists (REMOVED: Header has own script now)
    var headerInstantSearchEnabled = document.querySelector('#header-instant-search-container') !== null;

    if (!algolia.full_results && !algolia.is_collection_results_page) {
      /**
       * If we aren't on the search page and neither on a collection page,
       * then there's no need to proceed
       */
      return;
    } else if (algolia.full_results) {
      /**
       * If we are on the search page and instant search isn't enabled,
       * then there's no need to proceed
       */
      if (!algolia.config.instant_search_enabled) {
        return;
      }
    } else if (algolia.is_collection_results_page) {
      /**
       * If we are on a collection page and instant search on collection isn't
       * enabled, then there's no need to proceed
       */
      if (!algolia.config.instant_search_enabled_on_collection) {
        return;
      }
    }

    /**
     * Array which will contain all filters to be applied while initiating the
     * search API call.
     */
    var searchFilters = [];

    var collectionFacetFilter = null;
    var collectionRulesContextValue = null;
    var collectionHandle = null;

    if (collectionPageEnabled) {
      var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
      collectionHandle =
        Boolean(matches) && matches.length === 2 ? matches[1] : null;

      if (algolia.config.collection_id_indexing) {
        collectionFacetFilter = algolia.current_collection_id
          ? 'collection_ids:"' + algolia.current_collection_id + '"'
          : null;
      } else {
        collectionFacetFilter = 'collections:"' + collectionHandle + '"';
      }

      // Add the collection filter to the list of search filters
      searchFilters.push(collectionFacetFilter);

      collectionRulesContextValue = algolia.config.collection_id_query_rules
        ? algolia.current_collection_id
        : collectionHandle;
    }

    // Filters for stock policy
    var stockPolicyFilter = null;
    if (algolia.config.stock_policy) {
      if (algolia.config.stock_policy === 'allow') {
        /**
         * For 'allow', we don't need to add any filter as we want to continue
         * displaying all out of stock items.
         */
      } else if (algolia.config.stock_policy === 'deny') {
        // For 'deny' we will filter out all items based on inventory quantity
        stockPolicyFilter = 'inventory_quantity > 0';
      } else if (algolia.config.stock_policy === 'continue') {
        /**
         * For 'continue' we will filter on `inventory_available` attribute whose
         * value is dependent on:
         * `inventory_quantity > 0 OR inventory_policy == 'continue'`
         */
        stockPolicyFilter = 'inventory_available:true';
      }

      // Add the stock policy filter to the list of search filters
      if (stockPolicyFilter) {
        searchFilters.push(stockPolicyFilter);
      }
    }

    var results_selector = collectionPageEnabled
      ? algolia.config.collection_css_selector
      : algolia.config.results_selector;

    var activeSortOrders =
      collectionPageEnabled && algolia.collectionSortOrders
        ? algolia.collectionSortOrders
        : algolia.sortOrders;

    // Only add the generic class selector if NOT on a collection page
    // This prevents selecting the header search container on collection pages
    if (!collectionPageEnabled) {
      results_selector += ', .algolia-shopify-instantsearch';
    }

    function getTrackedUiState(uiState) {
      var trackedUiState = {};
      Object.keys(uiState).forEach(function (k) {
        if (k === 'configure' || k === 'query' || k === 'search') {
          return;
        }
        trackedUiState[k] = uiState[k];
      });
      return trackedUiState;
    }

    /**
     * List of URL params which are "allowed" by InstantSearch.
     * These parameters won't be overwritten when the search state is written
     * to the URL.
     */
    var ALLOWED_FOREIGN_PARAMS = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
    ];
    var foreignRouteState;

    function singleIndex(indexName) {
      return {
        /**
         * `stateToRoute` method transforms the `uiState` object from InstantSearch
         * into an object that will then be serialized to construct the URL.
         */
        stateToRoute: function (uiState) {
          var route = getTrackedUiState(uiState[indexName] || {});
          route.search = uiState[indexName].query;
          return Object.assign({}, foreignRouteState, route);
        },

        /**
         * `routeToState` method transforms the route object into a `uiState` object
         * so that InstantSearch is initialized with the correct state from the
         * URL.
         */
        routeToState: function (routeState) {
          /**
           * Backup parameters from `routeState` into a different object
           * `foreignRouteState` so that we can re-inject them into the object
           * returned within `stateToRoute`.
           * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
           * array.
           */
          if (!foreignRouteState) {
            foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function (acc, key) {
              acc[key] = routeState[key];
              return acc;
            }, {});
          }

          var state = {};
          state[indexName] = getTrackedUiState(routeState || {});
          state[indexName].query = routeState.search;
          return state;
        },
      };
    }

    var instant = {
      colors: algolia.config.colors,
      distinct: Boolean(algolia.config.show_products),
      facets: {
        hidden:
          collectionPageEnabled && algolia.collectionHiddenFacets
            ? algolia.collectionHiddenFacets
            : algolia.hiddenFacets,
        shown:
          collectionPageEnabled && algolia.collectionShownFacets
            ? algolia.collectionShownFacets
            : algolia.shownFacets,
        list:
          collectionPageEnabled && algolia.collectionFacets
            ? algolia.collectionFacets
            : algolia.facets,
        widgets:
          collectionPageEnabled && algolia.collectionFacetsWidgets
            ? algolia.collectionFacetsWidgets
            : algolia.facetsWidgets,
      },
      hitsPerPage:
        collectionPageEnabled &&
          algolia.config.collections_full_results_hits_per_page
          ? algolia.config.collections_full_results_hits_per_page
          : algolia.config.products_full_results_hits_per_page,
      search: instantsearch({
        searchClient: algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
        ),
        insights: true,
        indexName: algolia.config.index_prefix + 'products' + index_suffix,
        routing: {
          stateMapping: singleIndex(algolia.config.index_prefix + 'products' + index_suffix),
        },
        searchFunction: function (searchFunctionHelper) {
          if (window.algoliaLoadingTimeout) clearTimeout(window.algoliaLoadingTimeout);
          var hitsContainer = document.querySelector('.collection-search') || document.querySelector('.algolia-shopify-instantsearch');
          if (hitsContainer) {
            hitsContainer.classList.add('product-loading');
          }

          // Set query parameters here because they're not kept when someone
          // presses the Back button if set in the `init` function of a custom widget
          var page = searchFunctionHelper.getPage();
          if (instant.distinct) {
            searchFunctionHelper.setQueryParameter('distinct', true);
          }

          // Assign any required filters
          if (searchFilters.length) {
            searchFunctionHelper.setQueryParameter(
              'filters',
              searchFilters.join(' AND ')
            );
          }

          var analyticsTags = (algolia && typeof algolia.getAnalyticsTags === 'function')
            ? algolia.getAnalyticsTags()
            : (window.algoliaShopify && typeof window.algoliaShopify.getAnalyticsTags === 'function')
              ? window.algoliaShopify.getAnalyticsTags()
              : [(document.documentElement.lang === 'ar' || window.location.pathname.startsWith('/ar/') ? 'language_ar' : 'language_en')];
          searchFunctionHelper.setQueryParameter('analyticsTags', analyticsTags);

          // Assign any required `ruleContexts` which are required for query rules
          // targeting collection pages
          if (collectionPageEnabled) {
            // Collection page merchandising:
            // If we are on a collection page, `collectionRulesContextValue` is defined
            if (collectionRulesContextValue) {
              searchFunctionHelper.setQueryParameter('ruleContexts', [
                collectionRulesContextValue.toString(),
              ]);
            } else {
              searchFunctionHelper.setQueryParameter('ruleContexts', []);
            }
          }

          searchFunctionHelper.setPage(page);
          searchFunctionHelper.search();
          // if (searchFunctionHelper.getPage() === 0) {
          //   // Don't scroll if we're in the header modal
          //   if (!document.querySelector('#header-instant-search-container')) {
          //     setTimeout(() => {
          //       const resultsContainer = document.querySelector('.ais-hits-container') ||
          //         document.querySelector('.ais-Hits');
          //       if (resultsContainer) {
          //         const headerHeight = parseInt(
          //           getComputedStyle(document.documentElement)
          //             .getPropertyValue('--header-height')
          //         ) || 100;

          //         window.scrollTo({
          //           top: headerHeight,
          //           behavior: 'smooth'
          //         });
          //       }
          //     }, 100);
          //   }
          // }
          if (searchFunctionHelper.getPage() === 0) {
            setTimeout(() => {
              const mainContainer = document.querySelector(results_selector);
              if (mainContainer) {
                const headerHeight = parseInt(
                  getComputedStyle(document.documentElement)
                    .getPropertyValue('--header-height')
                ) || 120;

                const offsetPosition = mainContainer.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              }
            }, 100);
          }
        },
      }),
      selector: results_selector + ', .algolia-shopify-instantsearch',
      sortOrders: activeSortOrders
    };

    instant.search.client.addAlgoliaAgent('Shopify Integration');

    algolia.instantsearch = instant;

    function readjust() {
      var width = instant.$results.offsetWidth;

      var suffix = 'lg';
      if (width < 400) suffix = 'xs';
      else if (width < 800) suffix = 'sm';
      else if (width < 1200) suffix = 'md';

      instant.$results.classList.remove('ais-results-size-xs');
      instant.$results.classList.remove('ais-results-size-sm');
      instant.$results.classList.remove('ais-results-size-md');
      instant.$results.classList.remove('ais-results-size-lg');
      instant.$results.classList.add('ais-results-size-' + suffix);

      // Also add to body for PLP facet CSS rules to work
      document.body.classList.remove('ais-results-size-xs');
      document.body.classList.remove('ais-results-size-sm');
      document.body.classList.remove('ais-results-size-md');
      document.body.classList.remove('ais-results-size-lg');
      document.body.classList.add('ais-results-size-' + suffix);
    }


    //Link CSS and set up CSS variables
    //const cssFile = document.getElementById('template_algolia_instant_search.css');
    document.documentElement.style.setProperty(`--main-color`, `${algolia.config.colors.main}`);
    document.documentElement.style.setProperty(`--secondary-color`, `${algolia.config.colors.secondary}`);
    document.documentElement.style.setProperty(`--highlight-bg-color`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
    //algolia.appendStyle(cssFile.text);


    if (collectionPageEnabled) {
      if (
        document.querySelectorAll(algolia.config.collection_css_selector)
          .length === 0
      ) {
        throw new Error(
          'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
        );
      }
    } else if (
      document.querySelectorAll(algolia.config.results_selector).length === 0
    ) {
      throw new Error(
        'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
      );
    }

    // Instantiating the main page
    instant.$results = document.querySelector(instant.selector);
    instant.$results.innerHTML = '';

    // Debug logging
    // Use different template based on which container we're actually rendering into
    var isHeaderSearch = instant.$results && instant.$results.id === 'header-instant-search-container';
    var templateToUse = isHeaderSearch ? algolia.instantSearchHeaderTemplate : algolia.instantSearchMainTemplate;

    algolia.render(templateToUse, instant.$results, {
      facets: instant.facets.list,
      multipleSortOrders: activeSortOrders.length > 1,
    });

    readjust();

    window.addEventListener('resize', function () {
      readjust();
    });

    // Mobile facets display
    instant.search.addWidgets([
      {
        init: function () {
          // Scoped to this instance's own container so the header search
          // overlay and the collection-page instant search (which share this
          // file) never attach duplicate listeners to each other's buttons -
          // that double-binding was causing a single click to open then
          // immediately re-close the drawer.
          const scope = instant.$results;
          const filterButtons = scope.querySelectorAll('.ais-facets-button');
          var $closeButtons = scope.querySelectorAll('.icon__close, #show-results-button');
          var $facets = scope.querySelector('.ais-facets');

          const originalFilterBar = scope.querySelector('.ais-search-header');
          const stickyFilterBtn = scope.querySelector('.ais-search-header-small');

          var isArLocale = (algolia && typeof algolia.isArabic === 'function')
            ? algolia.isArabic()
            : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));

          var toggleFacets = function () {
            const isOpen = $facets.classList.contains('ais-facets__shown');
            $facets.classList.toggle('ais-facets__shown', !isOpen);
            document.body.classList.toggle('overflow-hidden', !isOpen);
            filterButtons.forEach(button => {
              button.classList.toggle('is-open', !isOpen);
            });
          };
          if (originalFilterBar && stickyFilterBtn) {
            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach(entry => {
                  stickyFilterBtn.style.display = entry.isIntersecting ? 'none' : 'flex';
                });
              },
              { threshold: 0.1 }
            );
            observer.observe(originalFilterBar);
          }
          // Collapse the bottom sticky bar to icon-only (Filter icon + its
          // counter badge, Sort icon) while the page is actively scrolling,
          // expanding back to full labels + selected-filter chips once
          // scrolling settles - mirrors the class-toggle pattern used above
          // for opening/closing the drawer itself.
          if (stickyFilterBtn && !stickyFilterBtn.dataset.collapseOnScrollBound) {
            stickyFilterBtn.dataset.collapseOnScrollBound = 'true';
            let collapseScrollTimeout;
            window.addEventListener('scroll', function () {
              stickyFilterBtn.classList.add('is-collapsed');
              clearTimeout(collapseScrollTimeout);
              collapseScrollTimeout = setTimeout(function () {
                stickyFilterBtn.classList.remove('is-collapsed');
              }, 400);
            }, { passive: true });
          }
          // Toggle facets on click of toggle button
          filterButtons.forEach(button => {
            if (isArLocale) {
              button.childNodes.forEach(node => {
                if (node.nodeType === 3 && node.textContent.trim() === 'Filter') {
                  node.textContent = node.textContent.replace('Filter', 'تصفية');
                }
              });
            }
            if (button.dataset.filterToggleBound) return;
            button.dataset.filterToggleBound = 'true';
            button.addEventListener('click', toggleFacets);
          });

          $closeButtons.forEach(btn => {
            if (btn.dataset.filterCloseBound) return;
            btn.dataset.filterCloseBound = 'true';
            btn.addEventListener('click', function () {
              if ($facets.classList.contains('ais-facets__shown')) {
                toggleFacets();
              }
            });
          });

          // Clicking the dimmed backdrop (anywhere outside the drawer and its
          // own toggle button) closes it, same as the close icon does.
          // Uses composedPath() instead of e.target.closest() because
          // refinementList widgets re-render (Preact) as soon as a value is
          // clicked, which can detach the clicked node before this delegated
          // listener runs - closest() on a detached node no longer finds
          // .ais-facets, which was wrongly closing the drawer on every
          // selection. composedPath() is captured at dispatch time, so it
          // stays accurate regardless of DOM mutations mid-click.
          if (!scope.dataset.overlayCloseBound) {
            scope.dataset.overlayCloseBound = 'true';
            scope.addEventListener('click', function (e) {
              if (!$facets.classList.contains('ais-facets__shown')) return;
              var path = typeof e.composedPath === 'function' ? e.composedPath() : [e.target];
              var insideDrawer = path.some(function (el) {
                return el && el.classList && (el.classList.contains('ais-facets') || el.classList.contains('ais-facets-button'));
              });
              if (insideDrawer) return;
              toggleFacets();
            });
          }
        },
      },
    ]);
    instant.search.addWidgets([
      configure({
        hitsPerPage: instant.hitsPerPage,
        facetingAfterDistinct: Boolean(algolia.config.show_products),
        analyticsTags: (algolia && typeof algolia.getAnalyticsTags === 'function')
          ? algolia.getAnalyticsTags()
          : (window.algoliaShopify && typeof window.algoliaShopify.getAnalyticsTags === 'function')
            ? window.algoliaShopify.getAnalyticsTags()
            : [(document.documentElement.lang === 'ar' || window.location.pathname.startsWith('/ar/') ? 'language_ar' : 'language_en')],

      }),
    ]);

    // Search input
    if (!collectionPageEnabled) {
      instant.search.addWidgets([
        searchBox({
          container: '.ais-search-box-container',
          placeholder: algolia.translations.searchForProduct,
          showReset: false,
          showSubmit: false,
        }),
      ]);
    }

    // Logo & clear
    instant.search.addWidgets([
      {
        init: function (opts) {
          document
            .querySelector('.ais-clear-input-icon')
            .addEventListener('click', function () {
              opts.helper.setQuery('').search();
              var input = document.querySelector('.ais-search-box--input');
              input.value = '';
              input.focus();
            });
        },
        render: function (opts) {
          if (!opts.state.query) {
            document.querySelector('.ais-clear-input-icon').style.display =
              'none';
          } else {
            document.querySelector('.ais-clear-input-icon').style.display = '';
          }
        },
      },
    ]);

    // Stats
    instant.search.addWidgets([
      stats({
        container: '.ais-stats-container',
        templates: {
          text(data, { html }) {
            if (data.hasNoResults)
              return '';
            // return algolia.instantSearchStatsTemplate(data, html)
            var isAr = (algolia && typeof algolia.isArabic === 'function')
              ? algolia.isArabic()
              : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));
            const count = algolia.helpers.formatNumber(data.nbHits);
            const label = isAr ? 'منتج' : (data.nbHits === 1 ? 'product' : 'products');
            return html`${count} ${label}`;
          }
        }
      }),
      stats({
        container: '.ais-stats-container_mobile',
        templates: {
          text(data, { html }) {
            window.productSearchCount = data.nbHits;
            var isAr = (algolia && typeof algolia.isArabic === 'function')
              ? algolia.isArabic()
              : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));
            const btns = document.querySelectorAll('.collection-search .show-results-button, #show-results-button');
            btns.forEach(btn => {
              if (data.nbHits !== undefined) {
                btn.textContent = isAr ? `عرض ${data.nbHits} منتج` : `Show ${data.nbHits} Products`;
              }
            });
            // return algolia.instantSearchStatsTemplate(data, html)
            if (data.hasNoResults)
              return '';
            const count = algolia.helpers.formatNumber(data.nbHits);
            const label = isAr ? 'منتج' : (data.nbHits === 1 ? 'product' : 'products');
            return html`${count} ${label}`;
          }
        }
      }),
    ]);

    // Sort orders
    if (activeSortOrders.length > 1) {
      instant.search.addWidgets([
        sortBy({
          container: '.ais-sort-orders-container',
          items: instant.sortOrders,
          transformItems: function(items) {
            const activeItem = items.find(function(i) { return i.isRefined; });
            if (activeItem && typeof updateDynamicIndex === 'function') {
              updateDynamicIndex(activeItem.value);
            } else if (activeItem) {
              window.algoliaShopify = window.algoliaShopify || {};
              window.algoliaShopify.dynamicIndexName = activeItem.value;
            }
            var isAr = (algolia && typeof algolia.isArabic === 'function')
              ? algolia.isArabic()
              : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));
            if (isAr && algolia.AR_SORT_LABELS) {
              return items.map(function(item) {
                return Object.assign({}, item, {
                  label: algolia.AR_SORT_LABELS[item.label] || item.label
                });
              });
            }
            return items;
          }
        }),
      ]);
    }



    // Hidden facets
    var list = instant.facets.hidden.map(function (facet) {
      return facet.name;
    });
    instant.search.addWidgets([
      {
        getConfiguration: function () {
          return {
            facets: list,
            disjunctiveFacets: list,
          };
        },
        init: function () { },
      },
    ]);

    // Create the render function
    var createDataAttributes = function (refinement) {
      return Object.keys(refinement)
        .map(function (key) {
          return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
        })
        .join(' ');
    };

    var renderListItem = function (item) {
      var facet = instant.facets.list.find(function (f) {
        return f.name === item.label;
      });

      // The custom min/max price widget adds two numeric refinements
      // (>= min, <= max) - collapse them into a single "700-2,000 AED" chip
      // instead of two separate chips.
      if (item.label === 'price' && item.refinements.length > 1) {
        var priceMinRefinement = item.refinements.find(function (r) {
          return r.operator === '>=';
        });
        var priceMaxRefinement = item.refinements.find(function (r) {
          return r.operator === '<=';
        });
        if (priceMinRefinement && priceMaxRefinement) {
          var priceCurrencyCode = (algolia.helpers.activeCurrencyCode() || '').toUpperCase();
          var priceMinLabel = Math.floor(Number(priceMinRefinement.value)).toLocaleString('en');
          var priceMaxLabel = Math.ceil(Number(priceMaxRefinement.value)).toLocaleString('en');
          var priceCombinedLabel =
            priceMinLabel + '-' + priceMaxLabel + (priceCurrencyCode ? ' ' + priceCurrencyCode : '');

          return (
            '<li class="ais-current-refined-values--item">' +
            '  <a class="ais-current-refined-values--link ais-current-refined-values--link--price">' +
            '    <div>' +
            '      <div class="ais-current-refined-values--label">' +
            '      </div> ' +
            priceCombinedLabel + '<svg class="icon icon__close" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.251 6.251a.857.857 0 0 1 1.212 0L12 10.788l4.537-4.537a.857.857 0 0 1 1.283 1.131l-.071.081L13.212 12l4.537 4.537.071.08a.857.857 0 0 1-1.283 1.132L12 13.212 7.463 17.75a.857.857 0 0 1-1.283-1.131l.071-.081L10.788 12 6.25 7.463l-.071-.08A.857.857 0 0 1 6.25 6.25Z" fill-rule="evenodd" clip-rule="evenodd"></path></svg>' +
            '    </div>' +
            '  </a>' +
            '</li>'
          );
        }
      }

      return item.refinements
        .map(function (refinement) {
          return (
            '<li class="ais-current-refined-values--item">' +
            '  <a ' +
            createDataAttributes(refinement) +
            '    class="ais-current-refined-values--link">' +
            '    <div>' +
            '      <div class="ais-current-refined-values--label">' +
            '      </div> ' +
            refinement.label + '<svg class="icon icon__close" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.251 6.251a.857.857 0 0 1 1.212 0L12 10.788l4.537-4.537a.857.857 0 0 1 1.283 1.131l-.071.081L13.212 12l4.537 4.537.071.08a.857.857 0 0 1-1.283 1.132L12 13.212 7.463 17.75a.857.857 0 0 1-1.283-1.131l.071-.081L10.788 12 6.25 7.463l-.071-.08A.857.857 0 0 1 6.25 6.25Z" fill-rule="evenodd" clip-rule="evenodd"></path></svg>' +
            '    </div>' +
            '  </a>' +
            '</li>'
          );
        })
        .join('');
    };
    let hasFiredViewDFiltersOnLoad = false;

    // Registering a second, independent connectCurrentRefinements widget
    // instance for the sticky bar (alongside the drawer's) turned out to be
    // unreliable - its render callback only ever fired once, against a
    // container InstantSearch hadn't attached yet, and never fired again on
    // later refinement changes. Instead of depending on that widget lifecycle
    // twice, there's a single real widget (the drawer's) and its rendered
    // chips are mirrored into the sticky bar via plain DOM sync below.
    var stickyRefinementsMirrorContainer = null;

    var applyCurrentRefinementsChips = function (container, items, refine) {
      container.innerHTML =
        '<div class="ais-root ais-current-refined-values ais-facet">' +
        '  <ul class="ais-current-refined-values--list">' +
        items.map(renderListItem).join('') +
        '  </ul>' +
        '</div>';

      Array.prototype.slice
        .call(
          container.querySelectorAll(
            '.ais-current-refined-values--link'
          )
        )
        .forEach(function (element) {
          element.addEventListener('click', function (event) {
            // Merged price chip (see renderListItem) has no data-* refinement
            // attributes to reconstruct - clear both numeric refinements for
            // "price" directly instead of calling refine() with an empty item.
            if (event.currentTarget.classList.contains('ais-current-refined-values--link--price')) {
              var priceHelper = instant.search.helper;
              if (priceHelper) {
                priceHelper.removeNumericRefinement('price', '>=');
                priceHelper.removeNumericRefinement('price', '<=');
                priceHelper.search();
              }
              return;
            }
            var item = Object.keys(event.currentTarget.dataset).reduce(function (
              acc,
              key
            ) {
              var itemData = {};
              itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
              return algolia.assign({}, acc, itemData);
            },
              {});

            refine(item);
          });
        });
    };

    var renderCurrentRefinements = function (renderOptions) {

      var items = renderOptions.items;
      var refine = renderOptions.refine;
      var widgetParams = renderOptions.widgetParams;

      applyCurrentRefinementsChips(widgetParams.container, items, refine);

      if (
        stickyRefinementsMirrorContainer &&
        stickyRefinementsMirrorContainer !== widgetParams.container
      ) {
        applyCurrentRefinementsChips(stickyRefinementsMirrorContainer, items, refine);
      }

      // In the filter drawer, panel() only hides/empties this widget's own
      // container - the drawer's outer row (with its padding/border-bottom)
      // is a separate wrapper we added and needs hiding too, so no empty gap
      // is left when nothing is currently refined. Row count/height itself is
      // left to CSS (max-height + overflow-y: auto) rather than computed from
      // the chip count here, since how many chips fit per row depends on how
      // long their labels are (e.g. "ARMANI EXCHANGE" vs "ALBA") - a fixed
      // count-based height breaks/clips as soon as a long label forces an
      // extra wrap.
      var drawerCurrentRefinementsRow = widgetParams.container.closest(
        '.filter-drawer__current-refinements'
      );
      if (drawerCurrentRefinementsRow) {
        drawerCurrentRefinementsRow.style.display = items.length > 0 ? '' : 'none';
      }

      // Desktop inline chips row (sticky bar) - hidden whenever nothing is
      // currently refined, shown otherwise (actual desktop-only visibility is
      // handled in CSS).
      var inlineCurrentRefinementsRow = widgetParams.container.closest(
        '.ais-current-refined-wrapper--inline'
      );
      if (inlineCurrentRefinementsRow) {
        inlineCurrentRefinementsRow.style.display = items.length > 0 ? '' : 'none';
      }

      if (!hasFiredViewDFiltersOnLoad && items.length > 0) {
        hasFiredViewDFiltersOnLoad = true;
        const filters = [];

        items.forEach(item => {
          item.refinements.forEach(refinement => {
            filters.push(`${encodeURIComponent(item.label)}:${encodeURIComponent(refinement.label)}`);
          });
        });
        const user_Token = localStorage.getItem('_ALGOLIA_USER_TOKEN');
        // setTimeout(function(){
        //    aa('viewedFilters', {
        //     userToken: user_Token,
        //     index: `${window.algoliaShopify.config.index_prefix}products`,         
        //     eventName: 'viewedFilters',          
        //     filters: filters
        //   });
        // },500);

      }
    };

    // Create the custom widget
    var customCurrentRefinements = connectCurrentRefinements(
      renderCurrentRefinements
    );

    var hasRefinements = function (helper, facetsList) {
      return facetsList.some(function (f) {
        var isConjunctiveFacetRefined =
          helper.state.isConjunctiveFacet(f.name) &&
          helper.state.isFacetRefined(f.name);
        var isDisjunctiveFacetRefined =
          helper.state.isDisjunctiveFacet(f.name) &&
          helper.state.isDisjunctiveFacetRefined(f.name);
        var isHierarchicalFacetRefined =
          helper.state.isHierarchicalFacet(f.name) &&
          helper.state.isHierarchicalFacetRefined(f.name);

        var numericRefinements = helper.state.getNumericRefinements(f.name);
        var isNumericFacetRefined = Object.keys(numericRefinements).some(function (
          operator
        ) {
          return numericRefinements[operator].length > 0;
        });

        return (
          isNumericFacetRefined ||
          isConjunctiveFacetRefined ||
          isDisjunctiveFacetRefined ||
          isHierarchicalFacetRefined
        );
      });
    };

    /**
     * Decides whether the given `facetName` has any facet values available in
     * the current result set by checking the available `facets`,
     * `disjunctiveFacets` and `hierarchicalFacets`.
     */
    var hasFacetValues = function (resultState, facetName) {
      var isFacetValueAvailable = resultState.facets.some(function (facet) {
        return facet.name === facetName;
      });
      var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
        function (facet) {
          return facet.name === facetName;
        }
      );
      var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
        function (facet) {
          return facet.name === facetName;
        }
      );

      return (
        isFacetValueAvailable ||
        isDisjunctiveFacetValueAvailable ||
        isHierarchicalFacetValueAvailable
      );
    };

    var customCurrentRefinementsWithPanel = panel({
      hidden: function (options) {
        return !hasRefinements(options.helper, instant.facets.list);
      },
    })(customCurrentRefinements);

    var clearRefinementsWithPanel = panel({
      // hidden: function(options) {
      //   return !hasRefinements(options.helper, instant.facets.list);
      // },
    })(clearRefinements);

    // The sticky bar's chip container is filled by mirroring the drawer
    // widget's render output (see stickyRefinementsMirrorContainer above),
    // not by registering it as its own InstantSearch widget - see the note
    // above applyCurrentRefinementsChips for why.
    stickyRefinementsMirrorContainer = document.querySelector(
      '.ais-current-refined-values-container'
    );

    instant.search.addWidgets([
      clearRefinementsWithPanel({
        container: document.querySelector('.ais-clear-refinements-container'),
        templates: {
          resetLabel: algolia.translations.clearAll,
        },
      }),
    ]);
    // Same current-refinements chips, rendered a second time into the filter
    // drawer itself (below the "Filter" header) so active filters are visible
    // while the drawer is open, not just in the collection page's sticky bar.
    var drawerCurrentRefinementsContainer = document.querySelector(
      '.filter-drawer__current-refinements-container'
    );
    if (drawerCurrentRefinementsContainer) {
      instant.search.addWidgets([
        customCurrentRefinementsWithPanel({
          container: drawerCurrentRefinementsContainer,
        }),
      ]);
    }
    // for clearbutton
    const stickyClearRefinementsWithPanel = panel({
      hidden: function (options) {
        return !hasRefinements(options.helper, instant.facets.list);
      },
    })(clearRefinements);

    instant.search.addWidgets([
      stickyClearRefinementsWithPanel({
        container: document.querySelector('.ais-clear-refinements-container--sticky'),
        templates: {
          resetLabel: algolia.translations.clearAll,
        },
      }),
    ]);
    // Desktop-only inline chips row inside the sticky bar itself (see
    // .ais-current-refined-wrapper--inline in the markup/CSS). Uses the raw
    // (non-panel) widgets - visibility is handled by renderCurrentRefinements
    // toggling the row's own display, same pattern as the filter drawer row.
    var inlineCurrentRefinementsContainer = document.querySelector(
      '.ais-current-refined-values-container--inline'
    );
    if (inlineCurrentRefinementsContainer) {
      instant.search.addWidgets([
        customCurrentRefinements({
          container: inlineCurrentRefinementsContainer,
        }),
      ]);
    }
    var inlineClearRefinementsContainer = document.querySelector(
      '.ais-clear-refinements-container--inline'
    );
    if (inlineClearRefinementsContainer) {
      instant.search.addWidgets([
        clearRefinements({
          container: inlineClearRefinementsContainer,
          templates: {
            resetLabel: algolia.translations.clearAll,
          },
        }),
      ]);
    }
    /**
     * Setup the facets for search.
     * We are using a `panel` with a custom `hidden` function which will allow
     * us to hide the parent container of the facet if there are no facet values
     * available for that particular facet.
     */
    instant.facets.widgets.forEach(function (widget) {
      var facetWithPanel = panel({
        hidden: function (options) {
          var hide = !hasFacetValues(options.results, widget.params.attribute);
          var displayStyle = hide ? 'none' : '';

          /**
           * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
           * can work as expected. "." is supposed to be present for named tags
           * and metafield based facet names and "%" is present when the facet name has a space
           * in it because of the encoding.
           */
          var parentContainerClassName = '.ais-facet-' + encodeURIComponent(
            widget.params.attribute
          ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
          var parentContainer = document.querySelector(parentContainerClassName);

          if (parentContainer) {
            parentContainer.style.display = displayStyle;
          }

          return hide;
        },
      })(widget.widget);

      instant.search.addWidgets([facetWithPanel(widget.params)]);
    });

    // Hits
    instant.search.addWidgets([
      hits({
        container: '.ais-hits-container',
        showPrevious: true,
        templates: {
          item(hit, { html, components }) {
            return algolia.instantSearchProductTemplate(hit, html, components);
          },
          empty(results, { html }) {
            return algolia.instantSearchNoResultTemplate(html);
          },
          showPreviousText(data, { html }) {
            return html`<span>${algolia.translations.loadprevious}</span>`;
          },
          showMoreText(data, { html }) {
            const helper = instant.search.helper;
            const results = helper.lastResults;

            if (!results) return html`<span>${algolia.translations.loadmore}</span>`;

            const totalHits = results.nbHits;

            const hitsPerPage = helper.state.hitsPerPage;
            const currentPage = helper.state.page || 0;
            const loadedHits = (currentPage + 1) * hitsPerPage;
            const remainingHits = Math.max(0, totalHits - loadedHits);

            // Calculate exactly how many will load on next click
            const nextLoadCount = Math.min(hitsPerPage, remainingHits);
            var isAr = (algolia && typeof algolia.isArabic === 'function')
              ? algolia.isArabic()
              : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));
            return html`
            <span class="load-more-text">
              ${isAr ? 'تحميل المزيد' : 'Load Next'} 
              ${remainingHits > 0 ? ` ${nextLoadCount}` : ''}
            </span>
          `;
            // return html`<span>${algolia.translations.loadmore}</span>`;
          },
          searchableLoadingIndicator(data, { html }) {
            var isAr = (algolia && typeof algolia.isArabic === 'function')
              ? algolia.isArabic()
              : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));
            return html`<span>${isAr ? 'جاري التحميل...' : 'loading'}</span>`;
          }
        },
        transformItems: function (items) {
          return items.map(item => ({
            ...item,
            _distinct: instant.distinct,
            can_order:
              item.inventory_management !== 'shopify' ||
              item.inventory_policy === 'continue' ||
              item.inventory_quantity > 0,
            queryID: item.__queryID,
            productPosition: item.__position,
            index: instant.search.mainIndex.getIndexName()
          }));
        }
      })
    ]);

    // --- SEO PAGINATION WIDGET ---
    // This dynamically creates a hidden container and injects the standard numbered pagination widget.
    // It generates real <a href="?page=X"> links for search engines to crawl,
    // while keeping the visual "Load More" button intact for regular users.
    var seoPaginationContainer = document.createElement('div');
    seoPaginationContainer.className = 'ais-seo-pagination-container visually-hidden';
    seoPaginationContainer.style.position = 'absolute';
    seoPaginationContainer.style.width = '1px';
    seoPaginationContainer.style.height = '1px';
    seoPaginationContainer.style.overflow = 'hidden';
    seoPaginationContainer.style.clip = 'rect(0, 0, 0, 0)';
    seoPaginationContainer.style.whiteSpace = 'nowrap';
    seoPaginationContainer.style.border = '0';
    
    document.addEventListener('DOMContentLoaded', function() {
      var hitsContainer = document.querySelector('.ais-hits-container');
      if (hitsContainer && hitsContainer.parentNode) {
        hitsContainer.parentNode.appendChild(seoPaginationContainer);
      } else {
        document.body.appendChild(seoPaginationContainer);
      }
    });

    instant.search.addWidgets([
      pagination({
        container: seoPaginationContainer,
      })
    ]);
    // --- END SEO PAGINATION WIDGET ---
  instant.search.on('render', function () {
      initDesktopSortDropdown();
      
      const robotsMeta = document.querySelector('meta[name="robots"]');
      if (robotsMeta) {
        const currentUrl = window.location.search;
        const decodedUrl = decodeURIComponent(currentUrl);
        const hasAlgoliaFilters = decodedUrl.includes('refinementList[') || 
                                  decodedUrl.includes('range[') || 
                                  decodedUrl.includes('toggle[');
                                  
        let newRobots = hasAlgoliaFilters ? 'noindex, follow' : 'index, follow';
        
        // --- TEMP DEBUG: comment out after testing ---
        console.log('[Robots Debug] currentUrl:', currentUrl);
        console.log('[Robots Debug] decodedUrl:', decodedUrl);
        console.log('[Robots Debug] hasAlgoliaFilters:', hasAlgoliaFilters);
        console.log('[Robots Debug] approvedUrls:', window.themeApprovedFilterUrls);
        // --- END TEMP DEBUG ---

        if (hasAlgoliaFilters && window.themeApprovedFilterUrls) {
          const currentRelativeUrl = window.location.pathname + window.location.search;
          const cleanUrl = currentRelativeUrl.split('&page=')[0].split('?page=')[0];

          // --- TEMP DEBUG: comment out after testing ---
          console.log('[Robots Debug] cleanUrl to match:', cleanUrl);
          console.log('[Robots Debug] isApproved:', window.themeApprovedFilterUrls.includes(cleanUrl));
          // --- END TEMP DEBUG ---

          if (window.themeApprovedFilterUrls.includes(cleanUrl)) {
            newRobots = 'index, follow';
          }
        }
        
        // --- TEMP DEBUG: comment out after testing ---
        console.log('[Robots Debug] final robots value set to:', newRobots);
        // --- END TEMP DEBUG ---

        if (robotsMeta.getAttribute('content') !== newRobots) {
          robotsMeta.setAttribute('content', newRobots);
        }
      }
    });
    // Redirect to product on click
    instant.search.addWidgets([
      {
        init: function () {
          var container = document.querySelector('.ais-hits-container');
          container.addEventListener('click', function (e) {
            const cartButton = e.target.closest('.ais-hit--cart-button_custom');
            if (cartButton) {
              return;
            }
            var el = e.target;
            var hit;
            do {
              if (el.matches('.ais-product')) {
                hit = el;
                break;
              }
              el = el.parentNode;
            } while (el && el !== container);
            if (!hit) {
              return;
            }
            var $this = hit;
            var productHandle = $this.dataset.handle;
            var variant_id = $this.dataset.variantId;
            var distinct = $this.dataset.distinct;
            const isSearch = $this.dataset.source === 'search';

            // Construct the link we should redirect to
            var link = '';

            // If we're on a collection page and the handle is available
            // then prefix the product link with the collection handle
            if (collectionPageEnabled && collectionHandle) {
              link = `${window.Shopify.routes.root}collections/${collectionHandle}/products/${productHandle}`;
            } else {
              link = `${window.Shopify.routes.root}products/${productHandle}`;
            }

            // Add the variant ID details to redirect to a specific
            // variant ID if we are showing variants and not products
            if (distinct !== 'true') {
              link += '?variant=' + variant_id;
            }
            if (isSearch) {
              const objectID = hit.dataset.algoliaObjectid;
              const now = Date.now();
              window.lastAlgoliaClick = window.lastAlgoliaClick || { time: 0, id: null };
              
              if (!(window.lastAlgoliaClick.id === objectID && now - window.lastAlgoliaClick.time < 500)) {
                window.lastAlgoliaClick = { time: now, id: objectID };
                localStorage.setItem('algolia_queryID', hit.dataset.algoliaQueryid);
                localStorage.setItem('algolia_objectID', objectID);
                const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN');
                const _algoliaConfig2 = JSON.parse(localStorage.getItem('algolia_config') || '{}');
                const authenticatedUserToken2 = _algoliaConfig2.authenticatedUserToken || window.algoliaShopify?.authenticatedUserToken || undefined;
                
                aa('clickedObjectIDsAfterSearch', {
                  userToken: userToken,
                  authenticatedUserToken: authenticatedUserToken2,
                  index: window.algoliaShopify.dynamicIndexName || hit.dataset.algoliaIndex,
                  eventName: 'clickedObjectIDsAfterSearch',
                  queryID: hit.dataset.algoliaQueryid,
                  objectIDs: [objectID],
                  positions: [parseInt(hit.dataset.algoliaPosition, 10)]
                });
              }
            }
            window.location.href = link;
          });
        },
      },
    ]);

    // Add to cart
    instant.search.addWidgets([
      {
        init: function () {
          var container = document.querySelector('.ais-hits-container');
          container.addEventListener('click', function (e) {
            var el = e.target;
            var cartButton;
            do {
              if (el.matches('.ais-hit--cart-button')) {
                cartButton = el;
                break;
              }
              el = el.parentNode;
            } while (el && el !== container);
            if (!cartButton) {
              return;
            }

            e.stopPropagation();
            var $this = cartButton;
            var formId = $this.dataset.formId;

            if (formId) {
              document.getElementById(formId).submit();
            }
          });
        },
      },
    ]);
    function initFacetShowMoreToggle() {
      const facetWrappers = Array.from(document.querySelectorAll('.ais-facet-dropdown-wrapper'))
        .filter(wrapper => !wrapper.closest('#header-instant-search-container'));

      facetWrappers.forEach(wrapper => {
        const container = wrapper.querySelector('.ais-facet-dropdown-container');
        const items = container?.querySelectorAll('.ais-RefinementList-item') || [];
      });

    }
    function unifiedInit() {
      initFacetShowMoreToggle();
    }

    let sentViewedObjectIDs = new Set();
    let processing = false;
    let lastSearchSignature = '';

    instant.search.on('render', function () {
      // Always securely sync the global index state with the actual Algolia helper's current index on every render.
      const currentIndex = instant.search.helper?.lastResults?.index || instant.search.helper?.state?.index;
      if (currentIndex) {
        updateDynamicIndex(currentIndex);
      }
      
      unifiedInit();
      if (processing) return;

      // Do not process views if the results object hasn't actually changed 
      // (ignores intermediate loading states when a filter is clicked)
      if (instant.search.helper?.lastResults) {
        if (instant.search.helper.lastResults === window._lastAlgoliaPlpResults) {
          return;
        }
        window._lastAlgoliaPlpResults = instant.search.helper.lastResults;
      }

      processing = true;

      const state = instant.search.helper?.lastResults?._state || instant.search.helper?.state;
      if (state) {
        const currentSignature = JSON.stringify({
          q: state.query,
          f: state.facetsRefinements,
          n: state.numericRefinements,
          d: state.disjunctiveFacetsRefinements
        });
        if (currentSignature !== lastSearchSignature) {
          sentViewedObjectIDs.clear();
          lastSearchSignature = currentSignature;
        }
      }

      const currentHits = instant.search.helper?.lastResults?.hits || [];
      
      // Identify only the newly rendered objectIDs that haven't been tracked yet
      const newObjectIDs = currentHits
        .map(hit => hit.objectID)
        .filter(id => !sentViewedObjectIDs.has(id));

      if (newObjectIDs.length > 0) {
        // Mark as sent immediately to avoid duplicates in rapid consecutive renders
        newObjectIDs.forEach(id => sentViewedObjectIDs.add(id));

        const user_Token = localStorage.getItem('_ALGOLIA_USER_TOKEN');
        const _algoliaConfig = JSON.parse(localStorage.getItem('algolia_config') || '{}');
        const authenticatedUserToken = _algoliaConfig.authenticatedUserToken || window.algoliaShopify?.authenticatedUserToken || undefined;
        
        if (typeof aa === 'function') {
          setTimeout(() => {
            // Algolia API limits to 20 objectIDs per view event. Safely chunk them.
            for (let i = 0; i < newObjectIDs.length; i += 20) {
              const chunk = newObjectIDs.slice(i, i + 20);
              aa('viewedObjectIDs', {
                eventName: 'viewedObjectIDs',
                index: window.algoliaShopify?.dynamicIndexName || instant.search.helper?.lastResults?.index,
                objectIDs: chunk,
                userToken: user_Token,
                authenticatedUserToken: authenticatedUserToken
              });
            }
          }, 800);
        }
      }

      processing = false;

    });
    // No result actions
    instant.search.addWidgets([
      {
        init: function (opts) {
          var container = document.querySelector('.ais-hits-container');
          container.addEventListener('click', function (e) {
            var el = e.target;
            var clearFilters;
            do {
              if (el.matches('.ais-hit-empty--clear-filters')) {
                clearFilters = el;
                break;
              }
              el = el.parentNode;
            } while (el && el !== container);
            if (!clearFilters) {
              return;
            }

            var helper = opts.helper;
            helper.clearTags();
            instant.facets.list.forEach(function (facet) {
              helper.clearRefinements(facet.name);
            });
            helper.search();
          });

          container.addEventListener('click', function (e) {
            var el = e.target;
            var clearInput;
            do {
              if (el.matches('.ais-hit-empty--clear-input')) {
                clearInput = el;
                break;
              }
              el = el.parentNode;
            } while (el && el !== container);
            if (!clearInput) {
              return;
            }

            opts.helper.setQuery('').search();
            var input = document.querySelector('.ais-search-box--input');
            input.value = '';
            input.focus();
          });
        },
      },
    ]);

    // ===============================
    // ALGOLIA RULE BANNER (PLP)
    // ===============================
    instant.search.on('render', function () {

      window.algoliaLoadingTimeout = setTimeout(function() {
        var searchWrapper = document.querySelector('.collection-search') || document.querySelector('.algolia-shopify-instantsearch');
        if (searchWrapper) {
          searchWrapper.classList.remove('product-loading');
        }
      }, 400);

      var results = instant.search.helper?.lastResults;
      if (!results) return;

      // Always remove old banners first to prevent duplicates
      document.querySelectorAll('.collection-search .algolia-rule-banner').forEach(function (el) {
        el.remove();
      });
      document.querySelectorAll('.collection-search .algolia-rule-banner-wrapper').forEach(function (el) {
        el.remove();
      });

      // Inject banner if the current results have one in userData
      if (results.userData && results.userData.length) {
        results.userData.forEach(function(userDataItem) {
          if (userDataItem.banners && userDataItem.banners.length) {
            userDataItem.banners.forEach(function(bannerData) {
              console.log('Algolia PLP Rule Banner Data:', bannerData);
              
              if (bannerData.image) {
                var bannerNode = document.createElement('div');
                bannerNode.className = 'collection-banner algolia-rule-banner preloaded-banner';
                bannerNode.style.marginBottom = '20px';
                
                var srcsetAttr = "";
                if (bannerData.image.indexOf('cdn.shopify.com') !== -1) {
                  var srcsetList = [360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950].map(function(w) {
                    var base = bannerData.image.split('?')[0];
                    var query = bannerData.image.split('?')[1] ? '?' + bannerData.image.split('?')[1] : '';
                    var withoutSize = base.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master|original|\d+x\d*)(\.\w{2,4})$/i, '$2');
                    var newUrl = withoutSize.replace(/(\.[^.]+)$/, '_' + w + 'x$1');
                    return newUrl + query + ' ' + w + 'w';
                  });
                  srcsetAttr = 'srcset="' + srcsetList.join(', ') + '" sizes="100vw"';
                }

                bannerNode.innerHTML = `${bannerData.link ? `<a class="image-url" href="${bannerData.link}"> <img src="${bannerData.image}" ${srcsetAttr} alt="Collection Banner" width="1920" loading="eager" style="width:100%; height:auto; display:block;"> </a>` : `<img src="${bannerData.image}" ${srcsetAttr} alt="Collection Banner" width="1920" loading="eager" style="width:100%; height:auto; display:block;">`}`;

                var collectionSearch = document.querySelector('.collection-search');
                if (collectionSearch) {
                  var position = (bannerData.position || '').toLowerCase();
                  if (position === 'bottom') {
                    var hitsContainer = document.querySelector('.ais-hits-container');
                    if (hitsContainer) {
                      hitsContainer.appendChild(bannerNode);
                    } else {
                      collectionSearch.appendChild(bannerNode);
                    }
                  } else if (position === 'center') {
                    var hitsList = document.querySelector('.ais-InfiniteHits-list');
                    if (hitsList) {
                      var products = hitsList.querySelectorAll('.ais-InfiniteHits-item:not(.algolia-rule-banner-wrapper)');
                      if (products.length > 0) {
                        var half = Math.floor(products.length / 2);
                        var liNode = document.createElement('li');
                        liNode.className = 'collection-banner-wrapper algolia-rule-banner-wrapper ais-InfiniteHits-item';
                        liNode.style.gridColumn = '1 / -1';
                        liNode.style.width = '100%';
                        liNode.style.listStyle = 'none';
                        liNode.appendChild(bannerNode);
                        products[half - 1].after(liNode);
                      } else {
                        collectionSearch.prepend(bannerNode);
                      }
                    } else {
                      collectionSearch.prepend(bannerNode);
                    }
                  } else {
                    collectionSearch.prepend(bannerNode);
                  }
                }
              }
            });
          }
        });
      }
    });

    instant.search.start();
  document.addEventListener('click', function(e){

    const confirmBtn = e.target.closest('.collection-search .show-results-button');
    if (!confirmBtn) return;

    requestAnimationFrame(() => {

      const helper = window.algoliaShopify.instantsearch.search.helper;
      if (!helper) return;

      const state = helper.state;

      let count = 0;

  Object.values(state.disjunctiveFacetsRefinements || {}).forEach(v=>{
    count += v.length;
  });

  Object.values(state.facetsRefinements || {}).forEach(v=>{
    count += v.length;
  });

  Object.values(state.numericRefinements || {}).forEach(operators=>{
    Object.values(operators).forEach(values=>{
      if (values.length) count += 1;
    });
  });

      const counters = document.querySelectorAll('main .filter-count');

      counters.forEach(el=>{
        el.textContent = count > 0 ? count : '';
        el.style.display = count ? 'inline-block' : 'none';
      });

    });

  });


  document.addEventListener('click', function(e){

    const closeBtn = e.target.closest('main .filter-count');
    if (!closeBtn) return;

    requestAnimationFrame(() => {

      const helper = window.algoliaShopify.headerInstantSearch.search.helper;
      if (!helper) return;

      const state = helper.state;

      let count = 0;

  Object.values(state.disjunctiveFacetsRefinements || {}).forEach(v=>{
    count += v.length;
  });

  Object.values(state.facetsRefinements || {}).forEach(v=>{
    count += v.length;
  });

  Object.values(state.numericRefinements || {}).forEach(operators=>{
    Object.values(operators).forEach(values=>{
      if (values.length) count += 1;
    });
  });

      const counters = document.querySelectorAll('main .filter-count');

      counters.forEach(el=>{
        el.textContent = count > 0 ? count : '';
        el.style.display = count ? 'inline-block' : 'none';
      });

    });

  });

    algolia.contentHide.parentNode.removeChild(algolia.contentHide);


    function updatePlpFilterCount() {
    const helper = window.algoliaShopify?.instantsearch?.search?.helper;
    if (!helper) return;

    const state = helper.state;

    let count = 0;

    Object.values(state.disjunctiveFacetsRefinements || {}).forEach(v => {
      count += v.length;
    });

    Object.values(state.facetsRefinements || {}).forEach(v => {
      count += v.length;
    });

    const counters = document.querySelectorAll('main .filter-count');

    counters.forEach(el => {
      if (count > 0) {
        el.textContent = count;
        el.style.display = 'inline-block';
      } else {
        el.textContent = '';
        el.style.display = 'none';
      }
    });
  }
    instant.search.on('render', () => {
      // Force update the button text after each render
      // Scope to PLP/search results only — exclude the header search container
      const plpResults = instant.$results;
      const loadMoreBtn = plpResults
        ? plpResults.querySelector('.ais-InfiniteHits-loadMore')
        : null;
      const helper = instant.search.helper;
      const results = helper.lastResults;
      var isAr = (algolia && typeof algolia.isArabic === 'function')
        ? algolia.isArabic()
        : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));

      if (loadMoreBtn) {
        if (!results) return;
        const totalHits = results.nbHits;
        const hitsPerPage = helper.state.hitsPerPage;
        const currentPage = helper.state.page || 0;
        const loadedHits = (currentPage + 1) * hitsPerPage;

        const remainingHits = Math.max(0, totalHits - loadedHits);
        const nextLoadCount = Math.min(hitsPerPage, remainingHits);
        const textSpan = loadMoreBtn.querySelector('.load-more-text');
        if (textSpan) {
          textSpan.textContent = isAr
            ? `تحميل المزيد ${remainingHits > 0 ? nextLoadCount : ''}`.trim()
            : `Load next ${remainingHits > 0 ? nextLoadCount : ''}`.trim();
        }
      }
      const tryInjectProgressBar = () => {
        // Only look inside PLP results container, never inside header search
        const hitsContainer = plpResults
          ? plpResults.querySelector('.ais-InfiniteHits-list')
          : null;
        if (!hitsContainer) return;
        // Only inject once per container
        let progressContainer = plpResults.querySelector('.custom-load-more-container');
        if (!progressContainer) {
          progressContainer = document.createElement('div');
          progressContainer.className = 'custom-load-more-container';
          progressContainer.innerHTML = `
            <div class="progress-text"></div>
            <div class="progress-bar"><div class="progress-fill"></div></div>
            <button type="button" class="ais-back-to-top" hidden>${isAr ? 'الرجوع إلى الأعلى' : 'Back to top'}</button>
          `;
          hitsContainer.parentNode.insertBefore(progressContainer, hitsContainer.nextSibling);

          // Bound once at creation, not per-render, so it never gets double-bound.
          progressContainer.querySelector('.ais-back-to-top').addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          });
        }

        if (results) {
          const totalHits = results.nbHits;
          const hitsPerPage = helper.state.hitsPerPage;
          const currentPage = helper.state.page || 0;
          const loadedHits = (currentPage + 1) * hitsPerPage;

          // const viewedHits = results.hits.length;
          const remainingHits = Math.max(0, totalHits - loadedHits);
          const viewedHits = Math.max(0, totalHits - remainingHits);
          const percentViewed = Math.min((viewedHits / totalHits) * 100, 100);

          const progressText = progressContainer.querySelector('.progress-text');
          const progressFill = progressContainer.querySelector('.progress-fill');
          const backToTopBtn = progressContainer.querySelector('.ais-back-to-top');

          if (progressText && progressFill) {
            progressText.textContent = isAr
              ? `عرض ${viewedHits} من أصل ${totalHits} منتج`
              : `Showing ${viewedHits} of ${totalHits} products`;
            progressFill.style.width = `${percentViewed}%`;
          }

          // Mirror the real "Load more" button's own --disabled class instead
          // of recomputing "is there more to load" independently - two
          // separate calculations of the same thing can update a tick apart,
          // which showed up as the old button lingering after the new one
          // had already appeared. Reading the button InstantSearch itself
          // already flagged keeps both in lockstep.
          if (backToTopBtn) {
            backToTopBtn.hidden = totalHits === 0 ||
              !(loadMoreBtn && loadMoreBtn.classList.contains('ais-InfiniteHits-loadMore--disabled'));
          }
        }
      };
      tryInjectProgressBar();
      requestAnimationFrame(updatePlpFilterCount);
    });
    // Add this function to create mobile sort popup
    function initMobileSortPopup() {
      // Find all results pages (PLP and Search Modal) but EXCLUDE header search which has its own logic
      const resultsPages = Array.from(document.querySelectorAll('.ais-page')).filter(el => !el.closest('#header-instant-search-container'));
      
      resultsPages.forEach(container => {
        // Get elements scoped to this container
        const mobileSortButton = container.querySelector('.mobile-sort-button');
        const bottomSortButton = container.querySelector('.bottom-sort-button');
        const mobileSortPopup = container.querySelector('.mobile-sort-popup');
        const mobileSortOptions = container.querySelector('.mobile-sort-options');
        const algoliaSelect = container.querySelector('.ais-sort-orders-container select');
        const closeButtons = container.querySelectorAll('.mobile-sort-close, .mobile-sort-overlay');
        const currentSortLabel = container.querySelector('.current-sort-label');
        const bottomSortLabel = bottomSortButton ? bottomSortButton.querySelector('.sort-label') : null;

        // Helper to bind a search button to the popup
        const bindSortButton = (button) => {
          if (!button) return;
          ["click", "touchend"].forEach(eventName => {
            button.addEventListener(eventName, (e) => {
              e.preventDefault();
              if (mobileSortPopup) {
                mobileSortPopup.classList.add('show');
                copySortOptions();
              }
            }, { passive: false });
          });
        };

        const updateCurrentSortLabel = () => {
          if (!algoliaSelect || (!currentSortLabel && !bottomSortLabel)) return;
          const selectedOption = algoliaSelect.options[algoliaSelect.selectedIndex];
          if (selectedOption) {
            if (currentSortLabel) currentSortLabel.textContent = selectedOption.textContent;
            // Relevance is always the first (default) sort index - the bottom
            // bar's tab keeps its "Sort" label for that default, and only
            // switches to showing the picked option's own name otherwise.
            if (bottomSortLabel) {
              var isAr = (algolia && typeof algolia.isArabic === 'function')
                ? algolia.isArabic()
                : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));
              bottomSortLabel.textContent = algoliaSelect.selectedIndex === 0
                ? (isAr ? 'ترتيب' : 'Sort')
                : selectedOption.textContent;
            }
          }
        };

        const highlightActiveOption = () => {
          if (!algoliaSelect || !mobileSortOptions) return;
          const selectedValue = algoliaSelect.value;
          const options = mobileSortOptions.querySelectorAll('.mobile-sort-option');
          options.forEach(option => {
            option.classList.toggle('active', option.dataset.value === selectedValue);
          });
        };

        const copySortOptions = () => {
          if (!algoliaSelect || !mobileSortOptions) return;
          mobileSortOptions.innerHTML = '';
          Array.from(algoliaSelect.options).forEach(option => {
            const button = document.createElement('button');
            button.className = 'mobile-sort-option';
            button.textContent = option.textContent;
            button.dataset.value = option.value;
            if (option.value === algoliaSelect.value) button.classList.add('active');

            button.addEventListener('click', () => {
              algoliaSelect.value = option.value;
              algoliaSelect.dispatchEvent(new Event('change'));
              
              highlightActiveOption();
              if (mobileSortPopup) mobileSortPopup.classList.remove('show');
            });
            mobileSortOptions.appendChild(button);
          });
        };

        // Initialization for this container
        if (mobileSortButton) {
          mobileSortButton.style.display = window.innerWidth <= 990 ? 'flex' : 'none';
          bindSortButton(mobileSortButton);
        }
        
        if (bottomSortButton) {
          bindSortButton(bottomSortButton);
        }

        if (closeButtons && mobileSortPopup) {
          closeButtons.forEach(btn => {
            btn.addEventListener('click', () => {
              mobileSortPopup.classList.remove('show');
            });
          });
        }

        if (algoliaSelect) {
          algoliaSelect.addEventListener('change', updateCurrentSortLabel);
          updateCurrentSortLabel();
        }

        // Handle window resize for this instance
        window.addEventListener('resize', () => {
          if (mobileSortButton) {
            mobileSortButton.style.display = window.innerWidth <= 990 ? 'flex' : 'none';
          }
        });
      });
    }

    // Add this function to create the desktop custom sort dropdown
    function initDesktopSortDropdown() {
      const resultsPages = Array.from(document.querySelectorAll('.ais-page')).filter(el => !el.closest('#header-instant-search-container'));

      resultsPages.forEach(container => {
        const desktopSortContainer = container.querySelector('.desktop-sort-container');
        const desktopSortTrigger = container.querySelector('.desktop-sort-trigger');
        const desktopSortPanel = container.querySelector('.desktop-sort-panel');
        const desktopSortLabel = container.querySelector('.desktop-sort-label');
        const algoliaSelect = container.querySelector('.ais-sort-orders-container select');

        if (!desktopSortContainer || !desktopSortTrigger || !desktopSortPanel || !algoliaSelect) return;
        if (desktopSortContainer.dataset.listenerAttached) return;
        desktopSortContainer.dataset.listenerAttached = 'true';

        const closeDropdown = () => {
          desktopSortContainer.classList.remove('open');
          desktopSortTrigger.setAttribute('aria-expanded', 'false');
        };

        const openDropdown = () => {
          buildOptions();
          desktopSortContainer.classList.add('open');
          desktopSortTrigger.setAttribute('aria-expanded', 'true');
        };

        const updateLabel = () => {
          const selectedOption = algoliaSelect.options[algoliaSelect.selectedIndex];
          if (selectedOption && desktopSortLabel) {
            desktopSortLabel.textContent = selectedOption.textContent;
          }
        };

        const buildOptions = () => {
          desktopSortPanel.innerHTML = '';
          Array.from(algoliaSelect.options).forEach(option => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'desktop-sort-option';
            button.textContent = option.textContent;
            button.dataset.value = option.value;
            button.setAttribute('role', 'option');
            if (option.value === algoliaSelect.value) {
              button.classList.add('active');
              button.setAttribute('aria-selected', 'true');
            }

            button.addEventListener('click', () => {
              algoliaSelect.value = option.value;
              algoliaSelect.dispatchEvent(new Event('change'));
              
              updateDynamicIndex(option.value);
              console.log('Algolia Desktop Sort Changed -> Index updated to:', option.value);
              
              updateLabel();
              closeDropdown();
            });
            desktopSortPanel.appendChild(button);
          });
        };

        desktopSortTrigger.addEventListener('click', (e) => {
          e.preventDefault();
          if (desktopSortContainer.classList.contains('open')) {
            closeDropdown();
          } else {
            openDropdown();
          }
        });

        document.addEventListener('click', (e) => {
          if (!desktopSortContainer.contains(e.target)) {
            closeDropdown();
          }
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') closeDropdown();
        });

        algoliaSelect.addEventListener('change', updateLabel);
        updateLabel();
      });
    }

    // Initialize when page loads or when Algolia renders
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(initMobileSortPopup, 2000);
        setTimeout(initDesktopSortDropdown, 2000);
      });
    } else {
      setTimeout(initMobileSortPopup, 2000);
      setTimeout(initDesktopSortDropdown, 2000);
    }

    instant.search.on('render', function () {
      initDesktopSortDropdown();
      if (typeof window.reloadThirdPartyWishlistApp === 'function') {
        window.reloadThirdPartyWishlistApp();
      }
    });

  })(window.algoliaShopify);
  function sendViewedFiltersOnLoad() {
    const viewedFilters = [];
    const facetGroups = Array.from(document.querySelectorAll('.ais-facet'))
      .filter(facet => facet.closest('.ais-facet-dropdown-wrapper') && !facet.closest('#header-instant-search-container'));
    let facetCount = 0;

    facetGroups.forEach(group => {
      const dropdownWrapper = group.closest('.ais-facet-dropdown-wrapper');
      const groupName = dropdownWrapper.querySelector('.ais-facet--header')?.innerText.trim() || '';

      if (!groupName) return;

      const isPriceFacet = group.closest('.ais-facet-price');
      if (isPriceFacet) {
        if (facetCount >= 10) return;
        const lowerHandle = isPriceFacet.querySelector('.rheostat-handle-lower');
        const upperHandle = isPriceFacet.querySelector('.rheostat-handle-upper');

        const minVal = lowerHandle ? lowerHandle.getAttribute('aria-valuenow') : '';
        const maxVal = upperHandle ? upperHandle.getAttribute('aria-valuenow') : '';

        if (minVal || maxVal) {
          viewedFilters.push(`Price:${minVal || 'min'}-${maxVal || 'max'}`);
        } else {
          viewedFilters.push('Price:All');
        }
        facetCount++;
      }

      const options = Array.from(group.querySelectorAll('.ais-RefinementList-item')).map(item => {
        // Stop processing if we already have 10 values
        if (facetCount >= 10) return null;
        const checkbox = item.querySelector('input.ais-facet--checkbox');
        const label = item.querySelector('label.ais-facet--label')?.innerText.trim() || '';
        const cleanLabel = label.replace(/\s*\(\d+\)\s*$/, '').trim(); // remove count from label

        facetCount++;

        return {
          label: cleanLabel,
          value: checkbox?.dataset?.value || cleanLabel
        };
      }).filter(option => option !== null);

      options.forEach(option => {
        viewedFilters.push(`${groupName}:${option.label}`);
      });

    });
    sendAlgoliaViewedFiltersEvent(viewedFilters);
  }
  function sendAlgoliaViewedFiltersEvent(filters) {
    if (!filters || filters.length === 0) {

      return;
    }

    const user_Token = localStorage.getItem('_ALGOLIA_USER_TOKEN');
    const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;
    const locale = window.Shopify.locale || 'en';
    let indexName;

    if (locale === 'ar') {
      indexName = 'shopify_products_saudi_arabia_ar';
    } else {
      indexName = `${window.algoliaShopify.config.index_prefix}products`;
    }

    setTimeout(function () {
      aa('viewedFilters', {
        userToken: user_Token,
        authenticatedUserToken: authenticatedUserToken,
        index: window.algoliaShopify.dynamicIndexName || indexName,
        eventName: 'viewedFilters',
        filters: filters.slice(0, 20) // Enforce Algolia API max limit of 20 items
      });
    }, 500);
  }
  function handleDropdownToggle(dropdownWrapper, facetCount = 0) {
    if (!dropdownWrapper) return;
    const { viewedFilters, facetCount: updatedCount } = getViewedFiltersForDropdown(dropdownWrapper);
    if (viewedFilters.length > 0) {
      sendAlgoliaViewedFiltersEvent(viewedFilters);
    }
    return updatedCount;
  }
  function getViewedFiltersForDropdown(dropdownWrapper, facetCount = 0) {
    const viewedFilters = [];

    if (!dropdownWrapper) return viewedFilters;

    const groupName = dropdownWrapper.querySelector('.ais-facet--header')?.innerText.trim() || '';
    if (!groupName) return viewedFilters;

    // Handle price facet first
    if (dropdownWrapper.classList.contains('ais-facet-price') || dropdownWrapper.querySelector('.ais-facet-price')) {
      if (facetCount < 10) {
        const lowerHandle = dropdownWrapper.querySelector('.rheostat-handle-lower');
        const upperHandle = dropdownWrapper.querySelector('.rheostat-handle-upper');
        const min = lowerHandle?.getAttribute('aria-valuenow');
        const max = upperHandle?.getAttribute('aria-valuenow');

        if (min || max) {
          viewedFilters.push(`${groupName}:${min || 'min'}-${max || 'max'}`);
        } else {
          viewedFilters.push(`${groupName}:All`);
        }
        facetCount++;
      }
      return { viewedFilters, facetCount };
    }

    // Get the facet group inside this dropdown
    const facetGroup = dropdownWrapper.querySelector('.ais-facet');
    if (!facetGroup) return { viewedFilters, facetCount };

    // Get first visible filter values up to 10 total
    Array.from(facetGroup.querySelectorAll('.ais-RefinementList-item')).forEach(item => {
      if (facetCount >= 10) return;

      const label = item.querySelector('label.ais-facet--label')?.innerText.trim() || '';
      const cleanLabel = label.replace(/\s*\(\d+\)\s*$/, '').trim();
      if (cleanLabel) {
        viewedFilters.push(`${groupName}:${cleanLabel}`);
        facetCount++;
      }
    });
    return { viewedFilters, facetCount };
  }
  function onAlgoliaRendered(callback) {
    const runCallback = () => {
      const algoliaContainer = document.querySelector('.ais-facets');
      if (!algoliaContainer) return false;

      // Ensure there are facet items inside
      const facets = algoliaContainer.querySelectorAll('.ais-facet');
      if (facets.length === 0) return false;

      callback();
      return true;
    };

    if (!runCallback()) {
      const observer = new MutationObserver((mutations, obs) => {
        if (runCallback()) {
          obs.disconnect();
        }
    });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
  // The previous sendViewedFiltersOnLoad() was removed and moved to the click listener below.
  function updateDynamicIndex(indexName) {
    if (!indexName) return;
    window.algoliaShopify = window.algoliaShopify || {};
    window.algoliaShopify.dynamicIndexName = indexName;
    const al_config = JSON.parse(localStorage.getItem('algolia_config') || '{}');
    al_config.index_name = indexName;
    // Preserve existing fields including authenticatedUserToken
    if (window.algoliaShopify.authenticatedUserToken) {
      al_config.authenticatedUserToken = window.algoliaShopify.authenticatedUserToken;
    }
    localStorage.setItem('algolia_config', JSON.stringify(al_config));
  }

  // --- Algolia Viewed Filters via ais-facets-button and category tabs ---
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.ais-facets-button');
    const categoryBtn = e.target.closest('.filter-drawer__category');
    
    if (!btn && !categoryBtn) return;
    
    // Scope queries to the current search instance (Header vs PLP)
    const wrapper = (btn || categoryBtn).closest('.ais-page, .algolia-shopify-instantsearch, #header-instant-search-container') || document;
    
    // Slight delay to ensure DOM is updated if drawer opens or tab switches
    setTimeout(() => {
      let activeCategory;
      let activePanel;

      if (categoryBtn) {
        activeCategory = categoryBtn;
        const target = categoryBtn.getAttribute('data-target');
        if (target) {
          activePanel = wrapper.querySelector(`.filter-drawer__panel[data-panel="${target}"]`) 
                     || wrapper.querySelector('.filter-drawer__panel.active');
        } else {
          activePanel = wrapper.querySelector('.filter-drawer__panel.active');
        }
      } else {
        activeCategory = wrapper.querySelector('.filter-drawer__category.active') || wrapper.querySelector('.filter-drawer__category');
        activePanel = wrapper.querySelector('.filter-drawer__panel.active') || wrapper.querySelector('.filter-drawer__panel');
      }
      
      if (!activeCategory || !activePanel) return;
      
      let groupName = activeCategory.innerText.trim();
      let viewedFilters = [];
      
      // Handle standard list items
      let items = activePanel.querySelectorAll('.ais-RefinementList-item');
      if (items.length > 0) {
        Array.from(items).forEach(item => {
          let label = item.innerText.trim(); // Captures "Banobagi\n5" format
          if (label) {
            viewedFilters.push(`${groupName}:${label}`);
          }
        });
      } else {
        // Handle Price or other facets without standard refinement list items
        const isPriceFacet = activePanel.classList.contains('ais-facet-price') || activePanel.querySelector('.ais-facet-price') || activeCategory.getAttribute('data-target') === 'price';
        if (isPriceFacet) {
          groupName = 'Price'; // Ensure title case for price
          const lowerHandle = activePanel.querySelector('.rheostat-handle-lower');
          const upperHandle = activePanel.querySelector('.rheostat-handle-upper');
          
          let minVal = lowerHandle ? (lowerHandle.getAttribute('aria-valuenow') || lowerHandle.getAttribute('aria-valuemin') || lowerHandle.innerText.trim()) : '';
          let maxVal = upperHandle ? (upperHandle.getAttribute('aria-valuenow') || upperHandle.getAttribute('aria-valuemax') || upperHandle.innerText.trim()) : '';

          // Fallback if inputs are used instead of rheostat
          if (!minVal && !maxVal) {
            const minInput = activePanel.querySelector('.ais-RangeInput-input--min, input[name="min"]');
            const maxInput = activePanel.querySelector('.ais-RangeInput-input--max, input[name="max"]');
            minVal = minInput ? (minInput.value || minInput.placeholder) : '';
            maxVal = maxInput ? (maxInput.value || maxInput.placeholder) : '';
          }

          if (minVal || maxVal) {
            viewedFilters.push(`${groupName}:${minVal || 'min'}-${maxVal || 'max'}`);
          } else {
            viewedFilters.push(`${groupName}:All`);
          }
        }
      }
      
      if (viewedFilters.length > 0) {
        sendAlgoliaViewedFiltersEvent(viewedFilters);
      }
    }, 300);
  });
  // ----------------------------------------------------------------------